import $ from 'jquery';
import { createApp } from 'vue/dist/vue.esm-bundler.js'

//====--------- import the individual components regardless if they are used inside other components
import listingModule from "Vue/components/listing";
import filtersModule from "Vue/components/filters";
import paginationModule from "Vue/components/pagination";

import PeopleListing from "Vue/components/people-listing/people-listing.vue";
import PeopleContacts from "Vue/components/people-listing/people-contacts.vue";
import PersonCard from "Vue/components/people-listing/person-card.vue";

import LatestInsights from "Vue/components/latest-insights/latest-insights.vue";
import InsightsTile from "Vue/components/latest-insights/insight-tile.vue";

import InsightsListing from "Vue/components/insights-listing/insights-listing.vue";

//====--------- each main category needs to be registered with a createApp
const PeopleListingComponent = createApp(PeopleListing);
const InsightsListingComponent = createApp(InsightsListing);

//====--------- Vue css selectors for containers of modules
const selectors = {
	ListingComponent: '.js-listing',
	FiltersComponent: '#js-filters',
	PaginationComponent: '#js-pagination'
};

//====--------- Vue element tags for registration
const moduleTags = {
	ListingTag: 'listing',
	FiltersTag: 'filters',
	PaginationTag: 'pagination'
}

//====--------- Mount the main category to a unique identifier

if ($('.PeopleListing').length) {
	PeopleListingComponent.component('person-card', PersonCard);
	PeopleListingComponent.component(moduleTags.FiltersTag, filtersModule);
	PeopleListingComponent.component(moduleTags.PaginationTag, paginationModule);
	PeopleListingComponent.mount('.PeopleListing');
}

if ($('.PeopleContacts').length) {
	const PeopleContactsElements = document.querySelectorAll('.PeopleContacts');

	PeopleContactsElements.forEach((element, index) => {

		const PeopleContactsComponent = createApp(PeopleContacts);

		PeopleContactsComponent.component('person-card', PersonCard);

		// Add unique identifier if not already present
		if (!element.id) {
			element.id = `people-contacts-${index}`;
		}

		PeopleContactsComponent.mount(`#${element.id}`);
	});
}

if ($('.LatestInsights').length) {
	const LatestInsightsElements = document.querySelectorAll('.LatestInsights');

	LatestInsightsElements.forEach((element, index) => {

		const LatestInsightsComponent = createApp(LatestInsights);

		LatestInsightsComponent.component('insight-tile', InsightsTile);

		// Add unique identifier if not already present
		if (!element.id) {
			element.id = `latest-insights-${index}`;
		}

		LatestInsightsComponent.mount(`#${element.id}`);
	});
}

if ($('.InsightsListing').length) {
	InsightsListingComponent.component('insight-tile', InsightsTile);
	InsightsListingComponent.component(moduleTags.FiltersTag, filtersModule);
	InsightsListingComponent.component(moduleTags.PaginationTag, paginationModule);
	InsightsListingComponent.mount('.InsightsListing');
}

//====--------- Listing Control Module

const module = {
	init: function () {
		module._initComponents();
		module._initControls();
	},
	_initComponents: function () {

		// Listing - optional filters and pagination componenets
		/*const ListingComponent = createApp({});

		ListingComponent.component(moduleTags.ListingTag, listingModule);
		ListingComponent.component(moduleTags.FiltersTag, filtersModule);
		ListingComponent.component(moduleTags.PaginationTag, paginationModule);

		if ($(selectors.ListingComponent).length) {
			ListingComponent.mount(selectors.ListingComponent);
		}*/
	},
	_initControls: function () {

		const ListingControls = document.querySelectorAll(selectors.ListingComponent);

		if (ListingControls.length) {

			for (let i = 0, l = ListingControls.length; i < l; i++) {

				const key = ListingControls[i].getAttribute('data-key');

				const component = createApp({});

				component.component(moduleTags.ListingTag, listingModule);
				component.component(moduleTags.FiltersTag, filtersModule);
				component.component(moduleTags.PaginationTag, paginationModule);

				component.mount(`${selectors.ListingComponent}[data-key="${key}"]`);
			}
		}
	}
};

module.init();